import { useContext, useMemo } from 'react'
import { useOptionalShopCountryContext } from '@cbgms/base/shop-country/shopCountryContext'
import { EnvironmentContext } from 'contexts/EnvironmentContext'
import { getXDomainCountry } from '@cbgms/base/utils/helpers'
import { ShopCountry } from '@cbgms/base/shop-id'

interface IUrlsPerCountry {
  [ShopCountry.GB]: string
  [ShopCountry.NL]: string
  [ShopCountry.BE]: string
  [ShopCountry.DE]: string
  [ShopCountry.FR]: string
}

export const useGetCountryForPolicyURLS = () => {
  const shopCountry = useOptionalShopCountryContext()
  const { environment } = useContext(EnvironmentContext)
  const domain = useMemo(() => getXDomainCountry(environment.XDomain), [environment.XDomain])
  const c = useMemo(() => {
    let country = domain?.toUpperCase()
    if (shopCountry && shopCountry.hasBeenProvided) {
      country = shopCountry.shopCountry.toUpperCase()
    }
    if (country === 'UK') {
      // We have to patch domain UK to use the GB urls.
      country = 'GB'
    }

    if (!Object.keys(ShopCountry).find(key => key === country)) {
      // This is not a valid country.  we will return a GB as default
      return 'GB'
    }

    return country as keyof IUrlsPerCountry
  }, [shopCountry, domain])

  return c
}
